import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import usePortal from '@/hooks/usePortal'

const Portal = ({ id, children, className }) => {
  const target = usePortal(id, className)

  if (!target) return null

  return createPortal(children, target)
}

Portal.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  className: PropTypes.string,
}

export default Portal
